import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.563 5.614a2.807 2.807 0 1 0 0-5.614 2.807 2.807 0 0 0 0 5.614m0 18.386a1.684 1.684 0 1 0 0-3.368 1.684 1.684 0 0 0 0 3.368M5.665 8.19a2.527 2.527 0 1 0 0-5.053 2.527 2.527 0 0 0 0 5.053M19.46 20.861a1.404 1.404 0 1 0 0-2.807 1.404 1.404 0 0 0 0 2.807M2.807 14.807a2.245 2.245 0 1 0 0-4.49 2.245 2.245 0 0 0 0 4.49m19.51-1.124a1.122 1.122 0 1 0 0-2.244 1.122 1.122 0 0 0 0 2.244M4.276 18.071a1.963 1.963 0 0 0 0 2.778 1.963 1.963 0 0 0 2.778 0 1.963 1.963 0 0 0 0-2.778 1.955 1.955 0 0 0-2.778 0M19.459 6.505a.842.842 0 1 0 0-1.683.842.842 0 0 0 0 1.683" }, null, -1)
  ])))
}
export default { render: render }